module.exports = __webpack_public_path__ + "img/sii-imagotipo.13b81ae7.svg";